
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { SummaryMethodParams } from 'element-ui/types/table';

@Component({
    name: 'DetailsTable',
})
export default class DetailsTable extends Vue {
    @Prop() protected tableData!: any;
    @Prop({
        default: 'trademark',
    }) protected type!: string;

    protected getSummaries(param: SummaryMethodParams) {
        const {columns, data} = param;
        const sums: string[] = [];
        columns.forEach((column: object, index: number) => {
            if (index === 0) {
                sums[index] = '';
                return;
            }
            if (index === 1 || index === 2) {
                sums[index] = '100%';
            }
        });
        return sums;
    }
}
